export const defaultNameStyle = {
  color: '#252350',
  fontWeight: 400,
};

export const defaultAvatarStyle = {
  width: 61,
  height: 61,
};
